module.exports = __webpack_public_path__ + "static/img/course4.008de020.jpg";